import { useTranslation } from 'react-i18next';
import appDownloadQr from '../assets/images/app-download-qr.png';
import downloadAppleStoreBadge from '../assets/images/download-apple-store-badge.svg?url';
import downloadGooglePlayBadge from '../assets/images/download-google-play-badge2.png';

const WonderschoolApp = () => {
  const { t } = useTranslation();
  return (
    <div className="mx-8 my-16 flex min-h-[40rem] w-11/12 border-2 border-gray-300 p-8">
      <div className="m-auto flex w-9/12 items-start gap-4 rounded-lg border-2 border-blue-200 p-8">
        <div className="flex flex-col items-center">
          <img src={appDownloadQr} alt={t('wonderschoolApp.qrCodeAlt')} />
          <div>{t('wonderschoolApp.scanToDownload')}</div>
        </div>
        <div className="flex flex-1 flex-col gap-6 text-left">
          <h1 className="text-3xl font-bold text-blue-900">{t('wonderschoolApp.downloadTheWonderschoolApp')}</h1>
          <div className="text-xl text-gray-800">{t('wonderschoolApp.messageEnrolledFamilies')}</div>
          <div className="flex justify-start gap-6">
            <div>
              <a href="https://apps.apple.com/us/app/wonderschool-2-0/id1560074981" target="_blank" rel="noreferrer">
                <img
                  style={{ height: '45px', width: 'auto' }}
                  src={downloadAppleStoreBadge}
                  alt={t('wonderschoolApp.downloadOnAppleAppStore')}
                />
              </a>
            </div>
            <div>
              <a
                href="https://play.google.com/store/apps/details?id=com.moxitinc.wonderschool"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  style={{ height: '45px', width: 'auto' }}
                  src={downloadGooglePlayBadge}
                  alt={t('wonderschoolApp.getItOnGooglePlay')}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WonderschoolApp;
